import { useEffect } from "react";
import { useAnalytics } from "@/contexts/analytics/hooks";
import type { RequestLedger, ShiftRequest } from "@/utils/models";
import { openingsOf } from "@/utils/requestOrigins";
import { hasUnknown, leadingEntry } from "@/utils/requestOriginsLedger";
import type { RequestOriginViewLevel } from "./requestOriginMeta";

/** Tracks one look at a request's origin, once per mount — its cards and panels mount only when they are opened. */
export const useTrackOriginViewed = (request: ShiftRequest, ledger: RequestLedger, level: RequestOriginViewLevel): void => {
	const { track } = useAnalytics();
	const kind = leadingEntry(ledger).kind;
	const causeCount = openingsOf(ledger.entries).length;
	const entryCount = ledger.entries.length;
	const unknown = hasUnknown(ledger);
	useEffect(() => {
		track("request_origin_viewed", {
			department_id: request.department_id,
			request_id: request.id,
			level,
			kind,
			cause_count: causeCount,
			entry_count: entryCount,
			has_unknown: unknown,
		});
	}, [track, request.department_id, request.id, level, kind, causeCount, entryCount, unknown]);
};
